import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';

const Features = () => {
  return (
    <div className="page-container">
      <Navbar />
      <main className="content-wrapper">
        <section className="page-header">
          <h1>AI-Powered Legal Solutions</h1>
          <p>Revolutionizing Legal Services with Advanced AI Solutions</p>
        </section>
        
        <section className="features-grid">
          <div className="feature-card">
            <h2>AI Legal Assistant</h2>
            <p>One-stop AI chatbot making legal language simple and accessible for everyone</p>
          </div>
          
          <div className="feature-card">
            <h2>Legal Research Agents</h2>
            <p>Advanced AI agents helping lawyers with complex legal research and analysis</p>
          </div>
          
          <div className="feature-card">
            <h2>Document Automation</h2>
            <p>Automated legal document processing for law firms and government agencies</p>
          </div>
          
          <div className="feature-card">
            <h2>Privacy-First Architecture</h2>
            <p>Local models and state-of-the-art infrastructure ensuring data security and compliance</p>
          </div>
        </section>
        
        <section className="feature-details">
          <h2>Why Choose LawSutra.AI</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <h3>Specialized AI Models</h3>
              <p>Fine-tuned solutions developed in partnership with research labs</p>
            </div>
            <div className="benefit-item">
              <h3>Indic Language Support</h3>
              <p>Partnership with foundational model providers for Indian language processing</p>
            </div>
            <div className="benefit-item">
              <h3>Expert-Backed Solutions</h3>
              <p>Developed in collaboration with lawyers and legal experts</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Features; 